import useGetFirstQuestions from './useGetFirstQuestions'
import useGetAutonomousNext from './useGetAutonomousNext'

export {
	useGetFirstQuestions,
	useGetAutonomousNext
}